import CloseIcon from "@mui/icons-material/Close";
import { ErrorBoundary } from "@sentry/react";
import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { setPageName } from "../../actions";
import "../../assets/styles/pages/domo.scss";
import { IframeLayout } from "../../components/Layouts";
import { BLACK, CYAN, TORCH_RED, WHITE } from "../../constants";
import { LookStudioEmbeddedLinks } from "../../constants/globalMSSalesConstants";
import { ThemeContext } from "../../context";
import { ErrorMsg } from "../AppMessages";
import { IframePageContent } from "../PageContent";
import { eventTracking, MixpanelEvents } from "../../utils/userTracking";

const Domo = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { theme } = useContext(ThemeContext);

  const [isRequestSubmitted, setIsRequestSubmitted] = useState(false);
  const [isNoticeDismissed, setIsNoticeDismissed] = useState(false);

  useEffect(() => {
    dispatch(setPageName(""));
  }, [dispatch]);

  const handleSubmitAccess = () => {
    eventTracking(MixpanelEvents.dashboard_access_request);
    setIsRequestSubmitted(true);
  };

  const handleClick = () => {
    history.push("/ccs_vital_signs/domo");
    setIsRequestSubmitted(false);
  };

  return (
    <IframeLayout hasFilter={true}>
      <ErrorBoundary fallback={<ErrorMsg />}>
        {/* Both children below need to land in .dashboard's single "body" grid cell (main.scss),
            stacked vertically - this wrapper is the one actual grid item there (see domo.scss),
            so IframePageContent's own #container (still carrying its usual grid-area: body from
            pageContainer.scss) just becomes an ordinary nested block instead of a second,
            overlapping grid item in the same cell. */}
        <div className="domo_page_body">
          {!isNoticeDismissed && (
            <div
              className="main_dashboard_domo"
              style={{
                backgroundColor: theme === "light" ? "#e7ecf0" : "#1a1a1a",
              }}
            >
              <button
                type="button"
                className="domo_notice_close"
                onClick={() => setIsNoticeDismissed(true)}
                aria-label="Dismiss this notice"
                data-test-id="domo-notice-close"
              >
                <CloseIcon fontSize="inherit" />
              </button>
              <div className="section">
                {isRequestSubmitted ? (
                  <div
                    onClick={handleClick}
                    className="back_button"
                    style={{
                      color: theme === "light" ? TORCH_RED : WHITE,
                    }}
                  >
                    &lt;
                    <span className="back_text">&nbsp; Back</span>
                  </div>
                ) : (
                  <>
                    <p
                      style={{
                        color: theme === "light" ? CYAN : WHITE,
                      }}
                    >
                      Access to the new CCS Vital Signs dashboard is managed by the CCS team. Please use the link below to request it.
                    </p>
                    <button
                      className="googleAccountBtn"
                      onClick={handleSubmitAccess}
                      style={{
                        color: theme === "light" ? WHITE : BLACK,
                      }}
                    >
                      SUBMIT ACCESS REQUEST
                    </button>
                  </>
                )}
              </div>
            </div>
          )}
          {isRequestSubmitted ? (
            <IframePageContent frameId="global_ms_sales_submitdomo" iframeUrl={LookStudioEmbeddedLinks.submit_domo_url} />
          ) : (
            <IframePageContent frameId="global_ms_sales_domo" iframeUrl={LookStudioEmbeddedLinks.domo_url} />
          )}
        </div>
      </ErrorBoundary>
    </IframeLayout>
  );
};

export default Domo;
